import Common from "./common.js"

class Contact extends Common {
  constructor() {
    super();
    var CI = this;
    CI.formValidation = {};
    CI.isPhone = false

    $(document).ready(function() {
      CI.validate("#lead-form")
      CI.validatePhone()

      $("#sbmtBtn").on('click', function() {
        $('#lead-form').parsley().whenValidate().done(function() {
          if (CI.isPhone == true){
            CI.postData();
          }
        });
      });
    });
  }
}

export default new Contact();
